import { AxiosResponse } from 'axios';
import { SET_PAYROLL_COMPONENTS, SET_PAYROLL_COMPONENT, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_PAYROLL_COMPONENT_ISLOADING,
  DELETE_PAYROLL_COMPONENT,
  EDIT_PAYROLL_COMPONENT,
  GET_PAYROLL_COMPONENTS,
  GET_PAYROLL_COMPONENT,
  REGISTER_PAYROLL_COMPONENT,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import PayrollComponent from '@/services/payroll_component';
import { Module } from 'vuex';
import { EditPayrollComponent, RegisterPayrollComponent, GetPayrollComponent } from '@/dtos/payroll_component.dto';

const payrollComponent: Module<any, {}> = {
  state: {
    payrollComponent: {
      data: null,
      isLoading: false,
    },
    payrollComponents: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    payrollComponent: (state: { payrollComponent: any }) => state.payrollComponent,
    payrollComponents: (state: { payrollComponents: any }) => state.payrollComponents,
  },
  mutations: {
    [SET_PAYROLL_COMPONENT]: (
      state: { payrollComponent: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.payrollComponent.data = payload.data) : null,
        (state.payrollComponent.isLoading = payload.isLoading);
    },
    [SET_PAYROLL_COMPONENTS]: (
      state: { payrollComponents: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.payrollComponents.data = payload.data) : null,
        (state.payrollComponents.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_PAYROLL_COMPONENT]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_COMPONENT, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollComponent.registerPayrollComponent(
        payload as RegisterPayrollComponent
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL_COMPONENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_COMPONENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_COMPONENT, { isLoading: false });
        return false;
      }
    },
    [GET_PAYROLL_COMPONENTS]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_COMPONENTS, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollComponent.getPayrollComponents(
        payload as GetPayrollComponent
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL_COMPONENTS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_COMPONENTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_COMPONENTS, { isLoading: false });
        return false;
      }
    },
    [GET_PAYROLL_COMPONENT]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_COMPONENT, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollComponent.getPayrollComponents(
        payload as GetPayrollComponent
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PAYROLL_COMPONENT, { data: result.data.data[0], isLoading: false });
          return result.data.data[0];
        }
        commit(SET_PAYROLL_COMPONENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_COMPONENT, { isLoading: false });
        return false;
      }
    },
    [EDIT_PAYROLL_COMPONENT]: async ({ commit }: any, payload: any) => {
      commit(SET_PAYROLL_COMPONENT, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollComponent.editPayrollComponent(
        payload as EditPayrollComponent
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PAYROLL_COMPONENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_COMPONENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_COMPONENT, { isLoading: false });
        return false;
      }
    },
    [DELETE_PAYROLL_COMPONENT]: async ({ commit }: any, payload: string) => {
      commit(SET_PAYROLL_COMPONENT, { data: null, isLoading: true });

      const result: AxiosResponse = await PayrollComponent.deletePayrollComponent(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PAYROLL_COMPONENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PAYROLL_COMPONENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PAYROLL_COMPONENT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_PAYROLL_COMPONENT_ISLOADING]: ({ commit }) => {
      commit(SET_PAYROLL_COMPONENT, { isLoading: false });
      commit(SET_PAYROLL_COMPONENTS, { isLoading: false });
    },
  },
};

export default payrollComponent;
